// extracted by mini-css-extract-plugin
export var banner = "_dm-0";
export var closeButton = "_dm-2";
export var greenCheckmark = "_dm-3";
export var hereLink = "_dm-4";
export var titleIcon = "_dm-1";